import { Component, Input } from '@angular/core';

@Component({
    selector: 'rx-banner',
    templateUrl: './rx-banner.component.html',
    styleUrls: ['./rx-banner.component.scss'],
    standalone: true
})
export class RxBannerComponent {
	/** Classic RX uses `default` (light blue info). Intuitive RX uses neutral grays on the gray canvas. */
	@Input() appearance: 'default' | 'intuitive' = 'default';

	@Input() type: 'notification' | 'info';
	@Input() message: string;

	get isIntuitiveAppearance(): boolean {
		return this.appearance === 'intuitive';
	}

	constructor() {}
}
